import './styles.scoped.css'
import {useEffect, useState} from 'react'
import {Typography, Button, IconButton} from '@mui/material'
import {Add, ArrowBack, Settings} from '@mui/icons-material'
import {accountApi} from '../../services'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'
import {useNavigate, Link} from 'react-router-dom'
import {DeleteRoleDialog} from './components'
import {useMobile} from '../../hooks'
import {parseError} from '../../utils/helpers'
import {SkeletonContainer, TextSkeleton, ButtonSkeleton} from '../../components'

export default () => {
    const [roles, setRoles] = useState([])
    const [openDeleteRoleDialog, setOpenDeleteRoleDialog] = useState(false)
    const [role, setRole] = useState(null)
    const [skeleton, setSkeleton] = useState(true)
    const {setLoading, setMessageBox} = useGlobalStates()
    const navigate = useNavigate()
    const {mobile} = useMobile()

    useEffect(() => {
        getRoles(true)
    }, [])

    // The first load shows the skeleton; a reload after a delete keeps the spinner.
    const getRoles = (initial = false) => {
        const setBusy = initial ? setSkeleton : setLoading
        setBusy(true)
        accountApi
            .getRoles()
            .then(
                ({
                    data: {
                        data: {roles},
                    },
                }) => {
                    setBusy(false)
                    setRoles(roles)
                },
            )
            .catch(error => {
                setBusy(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title, description})
                }
            })
    }

    const handleDeleteRole = role => {
        setRole(role)
        setOpenDeleteRoleDialog(true)
    }

    return (
        <>
            {mobile ? (
                <>
                    <div className="header">
                        <Link to="/team-management">
                            <IconButton>
                                <ArrowBack />
                            </IconButton>
                        </Link>
                        <Typography variant="h6" color="text.primary">
                            Role Settings
                        </Typography>
                    </div>
                    <br />
                    <br />
                    <br />
                    <Button variant="contained" fullWidth startIcon={<Add />} onClick={() => navigate('/team-management/role-settings/role-form')}>
                        Add New Role
                    </Button>
                </>
            ) : (
                <>
                    <Typography variant="body1" color="text.secondary">
                        Settings /{' '}
                        <Link className="link" to="/team-management">
                            Team Management Settings
                        </Link>{' '}
                        / Role Settings
                    </Typography>
                    <br />
                    <div className="header">
                        <div className="back-container">
                            <Link className="back-button" to="/team-management">
                                <ArrowBack style={{color: '#ffffff'}} fontSize="small" />
                            </Link>
                            <Typography variant="h5" color="text.primary">
                                Role Settings
                            </Typography>
                        </div>
                        <Button variant="contained" startIcon={<Add />} onClick={() => navigate('/team-management/role-settings/role-form')}>
                            Add New Role
                        </Button>
                    </div>
                </>
            )}
            <br />
            <br />
            {skeleton && (
                <SkeletonContainer className="card-container">
                    {[150, 110, 170, 130].map((width, index) => (
                        <div className="card" key={index}>
                            <div className="card-content">
                                <div>
                                    <TextSkeleton width={width} fontSize={20} />
                                    <br />
                                </div>
                                <div>
                                    <TextSkeleton width={100} />
                                    <br />
                                </div>
                            </div>
                            <div style={{display: 'flex', gap: 16}}>
                                <ButtonSkeleton width={index ? 116 : 150} />
                                {index > 0 && <ButtonSkeleton width={88} />}
                            </div>
                        </div>
                    ))}
                </SkeletonContainer>
            )}
            <div className="card-container">
                {Array.isArray(roles) &&
                    roles.map(role => (
                        <div className="card" key={role?.id}>
                            <div className="card-content">
                                <div>
                                    <Typography variant="h6" color="primary" className="role-name">
                                        {role?.display_name}
                                    </Typography>
                                    <br />
                                </div>
                                <div>
                                    <Typography variant="body2" color="text.secondary">
                                        Total Member: {role?.users_count ?? 0}
                                    </Typography>
                                    <br />
                                </div>
                            </div>
                            {role?.is_system ? (
                                <Button
                                    variant="outlined"
                                    startIcon={<Settings />}
                                    onClick={() => navigate(`/team-management/role-settings/role-form/${role?.id}`)}>
                                    View Settings
                                </Button>
                            ) : (
                                <>
                                    <Button
                                        variant="outlined"
                                        startIcon={<Settings />}
                                        style={{marginRight: 16}}
                                        onClick={() => navigate(`/team-management/role-settings/role-form/${role?.id}`)}>
                                        Settings
                                    </Button>
                                    <Button variant="contained" color="error" onClick={() => handleDeleteRole(role)}>
                                        Delete
                                    </Button>
                                </>
                            )}
                        </div>
                    ))}

                {Array.isArray(roles) && roles.length % 2 == 1 && <div className="card-transparent" key={roles.length} />}
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <DeleteRoleDialog open={openDeleteRoleDialog} setOpen={setOpenDeleteRoleDialog} roles={roles} role={role} reloadRoles={getRoles} />
        </>
    )
}
